/**
 * Objeto sendo as classes como a chave e a condição para serem criadas como
 * valor do objeto.
 *
 * @category DOM
 */
export type ObjectClasses = Record<string, boolean | undefined | string>;

/**
 * Converte objeto em uma string com as classes
 *
 * @param classes Objeto com chaves como classes e valores como condições para aplicarem essas classes.
 *
 * @category DOM
 *
 * @example
 * ```ts
 * import { generateClasses } from '@ids/tools';
 *
 * const position = 'bottom';
 * const align = 'end';
 * const type = 'click';
 * const className = 'custom-css-class';
 *
 * generateClasses({
 *   'tooltip': true,
 *   'tooltip--right': position === 'right',
 *   'tooltip--bottom': position === 'bottom',
 *   'tooltip--left': position === 'left',
 *   'tooltip--start': align === 'start',
 *   'tooltip--end': align === 'end',
 *   'tooltip--info': type === 'hover',
 *   [className]: className,
 * });
 * // resultado possível: 'tooltip tooltip--bottom tooltip--end custom-css-class'
 * ```
 */
export const generateClasses = (classes: ObjectClasses) =>
  Object.entries(classes)
    .reduce((string, [key, condition]) => (condition ? string + ' ' + key : string), '')
    .replace(/\s\s/g, ' ')
    .trim();
